import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        {/* Left wreath */}
        <path d="M7.6 4.6a1 1 0 0 0-1.5 1.3 8.5 8.5 0 0 1 0 10.9 1 1 0 1 0 1.5 1.3 10.5 10.5 0 0 0 0-13.5z" />
        {/* Right wreath */}
        <path d="M16.4 4.6a1 1 0 0 1 1.5 1.3 8.5 8.5 0 0 0 0 10.9 1 1 0 1 1-1.5 1.3 10.5 10.5 0 0 1 0-13.5z" />
        {/* Figure between them */}
        <rect x="10" y="8" width="4" height="2" rx="1" />
        <rect x="10" y="12" width="4" height="2" rx="1" />
        {/* Caption */}
        <rect x="6" y="20" width="12" height="1.8" rx="0.9" />
      </svg>
    ),
  },
});
